import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { FormControl } from '@angular/forms';
import { MultiselectComponent } from '@shared/components/multiselect/multiselect.component';
import { SharedModule } from '@shared/modules/shared.module';
import { UiCodeBlockComponent } from '../ui-code-block/ui-code-block.component';

@Component({
	selector: 'app-ui-multiselect',
	imports: [SharedModule, MultiselectComponent, UiCodeBlockComponent],
	templateUrl: './ui-multiselect.component.html',
	styleUrl: './ui-multiselect.component.scss',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class UiMultiselectComponent {
	@Input() multiselectControl!: FormControl;
	@Input() disabledMultiselectControl!: FormControl;
	@Input() errorMultiselectControl!: FormControl;

	// Sample options for examples
	countryOptions = [
		{ label: 'Andorra', value: 'ad' },
		{ label: 'España', value: 'es' },
		{ label: 'Emiratos Árabes Unidos', value: 'ae' },
		{ label: 'Francia', value: 'fr' },
		{ label: 'Alemania', value: 'de' },
		{ label: 'Italia', value: 'it' },
		{ label: 'Portugal', value: 'pt' },
		{ label: 'Reino Unido', value: 'gb' },
		{ label: 'Suiza', value: 'ch' },
		{ label: 'Países Bajos', value: 'nl' },
	];

	// Options with icons for list mode example (using same icon for all)
	countryListOptions = [
		{ label: 'Andorra', value: 'ad', icon: 'MapPin', iconType: 'lucide' as const },
		{ label: 'España', value: 'es', icon: 'MapPin', iconType: 'lucide' as const },
		{ label: 'Emiratos Árabes Unidos', value: 'ae', icon: 'MapPin', iconType: 'lucide' as const },
		{ label: 'Francia', value: 'fr', icon: 'MapPin', iconType: 'lucide' as const },
		{ label: 'Alemania', value: 'de', icon: 'MapPin', iconType: 'lucide' as const },
		{ label: 'Italia', value: 'it', icon: 'MapPin', iconType: 'lucide' as const },
		{ label: 'Portugal', value: 'pt', icon: 'MapPin', iconType: 'lucide' as const },
		{ label: 'Reino Unido', value: 'gb', icon: 'MapPin', iconType: 'lucide' as const },
		{ label: 'Suiza', value: 'ch', icon: 'MapPin', iconType: 'lucide' as const },
		{ label: 'Países Bajos', value: 'nl', icon: 'MapPin', iconType: 'lucide' as const },
	];

	generateCode(attrs: {
		formControl?: string;
		options?: string;
		placeholder?: string;
		label?: string;
		size?: string;
		disabled?: boolean;
		error?: boolean;
		errorMessage?: string;
		filter?: boolean;
		filterPlaceholder?: string;
		showSingleLabel?: boolean;
		displayMode?: string;
		showIcon?: boolean;
	}): string {
		let code = '<app-multiselect';

		if (attrs.formControl) code += `\n    [formControl]="${attrs.formControl}"`;
		if (attrs.options) code += `\n    [options]="${attrs.options}"`;
		if (attrs.placeholder) code += `\n    placeholder="${attrs.placeholder}"`;
		if (attrs.label) code += `\n    label="${attrs.label}"`;
		if (attrs.size) code += `\n    size="${attrs.size}"`;
		if (attrs.disabled) code += `\n    [disabled]="true"`;
		if (attrs.error) code += `\n    [error]="true"`;
		if (attrs.errorMessage) code += `\n    errorMessage="${attrs.errorMessage}"`;
		if (attrs.filter) code += `\n    [filter]="true"`;
		if (attrs.filterPlaceholder) code += `\n    filterPlaceholder="${attrs.filterPlaceholder}"`;
		if (attrs.showSingleLabel) code += `\n    [showSingleLabel]="true"`;
		if (attrs.displayMode) code += `\n    displayMode="${attrs.displayMode}"`;
		if (attrs.showIcon) code += `\n    [showIcon]="true"`;

		code += '\n/>';
		return code;
	}
}
